import { useParams } from 'react-router-dom';
import ListSteps from './ListSteps';
import { Formik } from 'formik';
import { AsyncCatalogAssociation } from 'src/app/api/openapi';
import { CatalogProductsClient } from 'src/app/api/clients/catalogProducts';

export interface AddFromListFormValues {
  activeStep: number;
  columns: string[];
  products: Record<string, string | number>[];
}

const AddProductsFromList = () => {
  const { merchantId, catalogId } = useParams();

  const handleAddProducts = (values: AddFromListFormValues) => {
    if (!merchantId || !catalogId) return;
    const formattedPayload: AsyncCatalogAssociation[] = values.products.map(
      (product: any) => ({
        gtin: `${product.sku}`,
        title: product.title || null,
        price: product.price
          ? { amount: product.price, currency_code: 'USD' }
          : null,
      })
    );
    CatalogProductsClient.queueProductsToCatalog(
      merchantId,
      catalogId,
      formattedPayload
    );
  };

  return (
    <Formik
      initialValues={
        {
          activeStep: 0,
          columns: ['sku', 'price'],
          products: [{ sku: '', price: '', index: 0 }],
        } as AddFromListFormValues
      }
      onSubmit={handleAddProducts}
    >
      {ListSteps}
    </Formik>
  );
};

export default AddProductsFromList;
